import Base from './Base';

class Staff extends Base {
  constructor() {
    super();

    this.id = 3;
    this.name = 'staff';
    this.searchQuery = 'staff';
    this.title = 'Staff';
  }

  getDefaultData(options = {}) {
    return {
      id: '',
      name: '',
      isNoPreference: false,
      isHidden: false,
      ...options,
      stepId: this.id,
    };
  }

  getData({ staff }) {
    return staff;
  }

  getRequestParams({ staff }) {
    return { staffId: staff.id };
  }

  getStepDataFromAppointment({ staff }, appointment) {
    return {
      ...staff,
      id: appointment.staffId,
      name: appointment.staffName,
    };
  }

  prepareResultData({ staff }) {
    return {
      staffId: staff.id,
      staffName: staff.name, // TODO: remove this line
    };
  }

  excludeStepDataFromParams(params) {
    const { staffId, ...restParams } = params;
    return restParams;
  }

  fetchRecords(params, props) {
    return props.loadStaffForBooking(params);
  }

  resetOptions({ staff }) {
    const nonResettableOptions = {
      isHidden: staff.allowToReset ? false : staff.isHidden,
    };
    return {
      staff: this.getDefaultData(nonResettableOptions),
    };
  }

  updateDataByRecords({ staff }, records) {
    if (records.length === 1) {
      const oneStaff = records[0];

      return {
        staff: {
          ...staff,
          ...oneStaff,
          name: oneStaff.formattedFullName,
          isHidden: true,
          allowToReset: true,
        },
      };
    }

    return {};
  }
}

export default Staff;
